import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import theme from './theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import OsList from './pages/OsList';
import OsForm from './pages/OsForm';
import OsLoteForm from './pages/OsLoteForm';
import Computadores from './pages/Computadores';
import Financeiro from './pages/Financeiro';
import Configuracoes from './pages/Configuracoes';
import AuditLogs from './pages/AuditLogs';
import FichaTecnica from './pages/FichaTecnica';
import ResetPassword from './pages/ResetPassword';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Carregando...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

      <Route path="/clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
      <Route path="/clientes/novo" element={<PrivateRoute><Clientes /></PrivateRoute>} />
      <Route path="/clientes/:id" element={<PrivateRoute><Clientes /></PrivateRoute>} />

      <Route path="/os" element={<PrivateRoute><OsList /></PrivateRoute>} />
      <Route path="/os/nova" element={<PrivateRoute><OsForm /></PrivateRoute>} />
      <Route path="/os/lote" element={<PrivateRoute><OsLoteForm /></PrivateRoute>} />
      <Route path="/os/:id" element={<PrivateRoute><OsForm /></PrivateRoute>} />

      <Route path="/computadores" element={<PrivateRoute><Computadores /></PrivateRoute>} />
      <Route path="/computadores/:id/ficha" element={<PrivateRoute><FichaTecnica /></PrivateRoute>} />

      <Route path="/financeiro" element={<PrivateRoute><Financeiro /></PrivateRoute>} />
      <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
      <Route path="/audit-logs" element={<PrivateRoute><AuditLogs /></PrivateRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
